export const lightTheme = {
  body: "#FAFAFA",
  text: "#363537",
  toggleBorder: "#FFF",
  background: "#FFF",
  menuBackground: "#F9F9F9",
  toggleText: "#FFF",
  columnHoverColor: "#DDD",
  columnAlternateColor: "#F2F2F2",
};

export const darkTheme = {
  body: "#363537",
  text: "#FFF",
  toggleBorder: "#6B8096",
  background: "#363537",
  menuBackground: "#090909",
  toggleText: "#FFF",
  columnHoverColor: "#999",
  columnAlternateColor: "#020202",
};
